// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1am2j","description":"PatientConsentPreview_description__1IZO_"};